import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

const TRUST_PORTAL_PERMISSION_VALUES = [
  {
    value: 'approved',
    label: 'Approved',
  },
  {
    value: 'closed',
    label: 'Denied',
  },
]

export const TrustPortalPermissionDropdown = (): JSX.Element => {
  return (
    <FilterDropdown
      filterParam={FilterParam.TRUST_PORTAL_PERMISSION}
      filterName={FilterName.TRUST_PORTAL_PERMISSION}
      filterValues={TRUST_PORTAL_PERMISSION_VALUES}
    />
  )
}
